import { METRIC_KEY, METRIC_TYPE } from '@/core/constants'
import { formatCost } from './formatFunctions'

const metricsChart = {
  [METRIC_KEY.roas]: {
    label: 'ROAS',
    type: METRIC_TYPE.percentage,
    positiveIncrease: true,
  },
  [METRIC_KEY.cost]: {
    label: 'Cost',
    type: METRIC_TYPE.currency,
    positiveIncrease: false,
  },
  [METRIC_KEY.conv_value]: {
    label: 'Conv. Value',
    type: METRIC_TYPE.number,
    positiveIncrease: true,
  },
  [METRIC_KEY.aov]: {
    label: 'Average Order Value',
    type: METRIC_TYPE.number,
    positiveIncrease: true,
  },
  [METRIC_KEY.cpa]: {
    label: 'CPA',
    type: METRIC_TYPE.currency,
    positiveIncrease: false,
  },
  [METRIC_KEY.conv]: {
    label: 'Conversions',
    type: METRIC_TYPE.number,
    positiveIncrease: true,
  },
  [METRIC_KEY.conv_rate]: {
    label: 'Conv. Rate',
    type: METRIC_TYPE.percentage,
    positiveIncrease: true,
  },
  [METRIC_KEY.clicks]: {
    label: 'Clicks',
    type: METRIC_TYPE.number,
    positiveIncrease: true,
  },
  [METRIC_KEY.ctr]: {
    label: 'CTR',
    type: METRIC_TYPE.percentage,
    positiveIncrease: true,
  },
  [METRIC_KEY.impressions]: {
    label: 'Impressions',
    type: METRIC_TYPE.number,
    positiveIncrease: true,
  },
  [METRIC_KEY.impression_share]: {
    label: 'Impression Share',
    type: METRIC_TYPE.percentage,
    positiveIncrease: true,
  },
  [METRIC_KEY.avg_cpc]: {
    label: 'Avg. CPC',
    type: METRIC_TYPE.currency,
    positiveIncrease: false,
  },
}

const calculateComparison = chartData => {
  const last = Number(chartData[chartData.length - 1])
  const secondToLast = Number(chartData[chartData.length - 2])

  if (secondToLast === 0) {
    if (last === 0) return 0
    return last > 0 ? 100 : -100
  }

  const percentageDiff = ((last - secondToLast) / secondToLast) * 100
  return Math.round(percentageDiff)
}

const getComparisonColor = (comparison, positiveIncrease) => {
  const threshold = 2
  switch (true) {
    case Math.abs(comparison) <= threshold:
      return 'text-bb-neutral-gray'
    case comparison > threshold && positiveIncrease:
    case comparison < -threshold && !positiveIncrease:
      return 'text-success'
    case comparison < -threshold && positiveIncrease:
    case comparison > threshold && !positiveIncrease:
      return 'text-bb-red-error'
    default:
      return 'text-bb-neutral-gray'
  }
}

const filterChartsByConversionValue = charts => {
  const convValueChart = charts.find(chart => chart.link === METRIC_KEY.conv_value)

  if (!convValueChart) return charts
  const hasValidConvValues = convValueChart.chartData.some(value => !!value)

  if (!hasValidConvValues) {
    return charts.filter(chart => ![METRIC_KEY.conv_value, METRIC_KEY.aov, METRIC_KEY.roas].includes(chart.link))
  }

  return charts
}

export const mapMetrics = (metrics, anomalies, dateRange) => {
  const processMetric = key => {
    const chartData = metrics[key].map(value => {
      if (value === null) return value
      const isPercentage = metricsChart[key].type === METRIC_TYPE.percentage
      return Number(formatCost(isPercentage ? value * 100 : value))
    })

    const comparison = calculateComparison(chartData)
    const comparisonColor = getComparisonColor(comparison, metricsChart[key].positiveIncrease)

    return {
      label: metricsChart[key].label,
      link: key,
      selected: false,
      type: metricsChart[key].type,
      positiveIncrease: metricsChart[key].positiveIncrease,
      labels: dateRange,
      chartData: chartData,
      comparison: comparison,
      comparisonColor: comparisonColor,
      anomaly: anomalies[key + '_issue'],
    }
  }

  const charts = Object.keys(metricsChart).map(processMetric)
  return filterChartsByConversionValue(charts)
}
